export default {
	element: null,
	timer: null,
};
